import { z } from 'zod';
import { ValidationEntrySeveritySchema } from '../../../../../react-commons/components/ValidationEntrySeverity';
import { ValidationEntryResultScopeTypeSchema } from '../../enumerations/ValidationEntryResultScopeType';
import { ValidationItemTypeSchema } from '../../enumerations/ValidationItemType';
import { IdSchema } from '../../resource-base/baseSchemas';
import { msObject } from '../../resource-base/msObject';

export const ScopeValidationItemSchema = msObject({
    type: ValidationEntryResultScopeTypeSchema,
    id: IdSchema,
    objectId: IdSchema.nullable(),
});

export const ValidationItemSchema = msObject({
    severity: ValidationEntrySeveritySchema,
    type: ValidationItemTypeSchema,
    identifier: z.string(),
    scope: ScopeValidationItemSchema.nullish(),
    propertyName: z.string().optional(),
    detailedMessages: z.string().array().nullish(),
});

export const CompoundValidationItemSchema = ValidationItemSchema.extend({
    properties: z.string().array().nullable(),
});

export type ValidationItem = z.infer<typeof ValidationItemSchema>;
export type CompoundValidationItem = z.infer<typeof CompoundValidationItemSchema>;
export type ScopeValidationItem = z.infer<typeof ScopeValidationItemSchema>;
